/**
 * Режим CRM по данным пользователя (iamuser).
 *
 * Возвращает:
 *   'full'    — полный доступ: школа 1 или роль crm;
 *   'shadule' — ограниченный (только расписание): есть своя группа (GroupId)
 *               или роль instructor в myGroupRole;
 *   null      — доступа нет.
 *
 * Единый источник правды для CRM (GroupCRM/context) и верхнего меню.
 */
export const getCrmMode = (iamuser) => {
    if (!iamuser) return null;

    // полный доступ: школа 1 ИЛИ пометка роли crm
    if (iamuser.SchoolId === 1 || (iamuser.myPortalRoles && iamuser.myPortalRoles.crm)) {
        return 'full';
    }

    // иначе — нужна хотя бы одна группа: своя (GroupId) или роль instructor
    const hasGroup = !!iamuser.GroupId || !!(
        iamuser.myGroupRole && iamuser.myGroupRole.some((role) => role.Role === 'instructor')
    );
    if (hasGroup) return 'shadule';

    return null;
};
